import React, {useEffect, useState} from "react";
import {Layout} from "components";
import {Row, Col, Button} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

import {getServiceChannels, getOtherChannels} from "services/api-service";

import {useDispatch, useSelector, batch} from "react-redux";
import {
    changeSelectedApptType,
    changeDefaultLocationId
} from "redux/appointmentBooking";

import {env} from "../env";

import {SING_PASS, APPOINTMENT, DEFAULT_ROUTE} from "constants/route";
import _ from "lodash";

import {
    BackButton,
    HomeButton,
    Instruction,
    Tooltip,
    CardButton
} from "components/CommonUI";

const ZERO = 0;

const DefaultModes = ({title}) => {
    const {subServiceId} = useSelector((state) => state.services);
    const [disclaimer, setDisclaimer] = useState(null);
    const [otherChannels, setOtherChannels] = useState([]);

    useEffect(() => {
        getOtherChannels(subServiceId).then(
            ({data}) => {
                const {disclaimer, otherChannels} = data;
                console.log("otherChannels", otherChannels)
                setDisclaimer(disclaimer);
                setOtherChannels(otherChannels);
            }
        );
    }, []);

    if(otherChannels.length === 0) {
        return <></>;
    }

    return (
        <>
            {title}
            <Row className="d-flex justify-content-center px-md-4">
                {otherChannels.map(o => (
                    <Col
                        xs={10}
                        sm={10}
                        md={6}
                        lg={4}
                        // className="d-flex justify-content-center align-item-center p-1"
                        style={{marginBottom: 20}}
                    >
                        <CardButton
                            icon={o.iconCode}
                            text={o.descriptionName}
                            subText={o.toolTip}
                            onClick={() => {
                                window.location.href = o.url;
                            }}
                        />
                    </Col>
                ))}

                {/*<Col*/}
                {/*    xs={10}*/}
                {/*    sm={10}*/}
                {/*    md={6}*/}
                {/*    lg={4}*/}
                {/*    // className="d-flex justify-content-center align-item-center p-1"*/}
                {/*    style={{marginBottom: 20}}*/}
                {/*>*/}
                {/*    <CardButton*/}
                {/*        icon={"icon-dls-email"}*/}
                {/*        text={"Write to us"}*/}
                {/*        subText={"Send us your feedback and questions."}*/}
                {/*        onClick={() => {*/}
                {/*            window.location.href = window.writeToUsLink;*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</Col>*/}
            </Row>
            {disclaimer && (
                <Row className="d-flex justify-content-center pb-3 pt-3">
                    <Col
                        xs={10}
                        md={10}
                        className="d-flex justify-content-center align-item-center p-1"
                    >
                        <Instruction>
                            {disclaimer}
                            {/*Disclaimer: Our staff are here to help and will treat*/}
                            {/*customers with courtesy, respect and professionalism. We ask*/}
                            {/*that you treat our staff the same manner you expect to be*/}
                            {/*treated. Indecent, threatening, abusive or insulting*/}
                            {/*behaviour will not be tolerated. We may refuse service to*/}
                            {/*anyone who is disrespectful towards our staff.*/}
                        </Instruction>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default function ServiceChannel() {
    const [channels, setChannels] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {age} = useSelector((state) => state.appointment);
    const {subServiceId, isCrps, isExperience} = useSelector((state) => state.services);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!_.isNumber(subServiceId)) {
            navigate(DEFAULT_ROUTE);
            return;
        }

        getServiceChannels(age, subServiceId, isCrps ? isCrps : false).then(
            ({data: serviceChannels}) => {
                serviceChannels.data && setChannels(serviceChannels.data);
            }
        );
    }, []);

    const goAppointmentBooking = async (
        id,
        displayText,
        defaultLocationId,
        openLink,
        apptTypeCode
    ) => {
        if (openLink) {
            window.location.href = openLink;
            return;
        }
        batch(() => {
            dispatch(
                changeSelectedApptType({
                    value: id,
                    label: displayText,
                    code: apptTypeCode
                })
            );
            dispatch(
                changeDefaultLocationId(defaultLocationId ? defaultLocationId : "")
            );
        });
        navigate(SING_PASS);
    };

    return (

        <Layout subHeader={"How can we help?"}>

            <div className="form-box">
                {channels.length !== ZERO ? (
                    <>
                        <h5 className="center text-secondary mt-2">
                            Make an appointment with us
                        </h5>
                        <br/>
                        <Row className="d-flex justify-content-center px-md-4">
                            {channels.map(
                                // {[1, 2, 3, 4].map(
                                ({
                                     id,
                                     icon_uuid,
                                     web_disp_text: displayText,
                                     default_location_id: defaultLocationId,
                                     open_link: openLink,
                                     tool_tip,
                                     appt_type_code: apptTypeCode
                                 }) => (
                                    <Col
                                        xs={10}
                                        sm={10}
                                        md={6}
                                        lg={4}
                                        // className="d-flex justify-content-center align-item-center p-1"
                                        key={id}
                                        style={{marginBottom: 20}}
                                    >
                                        <CardButton
                                            icon={icon_uuid}
                                            text={displayText}
                                            subText={tool_tip}
                                            onClick={() =>
                                                goAppointmentBooking(
                                                    id,
                                                    displayText,
                                                    defaultLocationId,
                                                    openLink,
                                                    apptTypeCode
                                                )
                                            }
                                        />
                                    </Col>
                                )
                            )}
                        </Row>
                        <Row className="d-flex justify-content-center pb-3 pt-3">
                            <Col
                                xs={10}
                                md={10}
                                className="d-flex justify-content-center align-item-center p-1"
                            >
                                <Instruction>
                                    You will need to log in with your Singpass and provide a valid
                                    Singapore-registered mobile number to make an appointment for
                                    yourself.
                                </Instruction>
                            </Col>
                        </Row>

                        <DefaultModes title={
                            <Row className="d-flex justify-content-center pb-1 pt-1">
                                <Col
                                    xs={10}
                                    md={10}
                                    className="d-flex justify-content-center align-item-center p-1"
                                >
                                    {/* <h4 className="center text-secondary mt-2"> */}
                                    Otherwise, we’ll be glad to help you in other ways
                                    {/* </h4> */}
                                </Col>
                            </Row>
                        }/>

                    </>
                ) : (
                    <>
                        <DefaultModes title={
                            <h5 className="center text-secondary mt-2">
                                How would you like to contact us?
                            </h5>
                        }/>
                        <br/>

                    </>
                )}


                <div className="form-footer">
                    <BackButton/>
                </div>

            </div>
        </Layout>
    );
}
